// extracted by mini-css-extract-plugin
export var base = "LogoGrid-module--base--aa9ad";
export var logo = "LogoGrid-module--logo--e1024";